<template>
  <div :class="['modal-cookie', isModal ? '-isModal' : '']">
    <div v-if="showTitle || showCloseBtn" class="modal-cookie_header header">
      <div v-if="showTitle" class="header_title">{{ $t('cookie.policySettings') }}</div>

      <div v-if="showCloseBtn" class="header_close" @click="close">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_6399_13262)">
            <path d="M16 14.1146L21.6573 8.45732C22.1779 7.9367 23.022 7.93669 23.5426 8.45732C24.0633 8.97794 24.0633 9.82203 23.5426 10.3426L17.8853 16L23.5426 21.6573C24.0633 22.1779 24.0633 23.022 23.5426 23.5426C23.022 24.0633 22.1779 24.0633 21.6573 23.5426L16 17.8853L10.3426 23.5426C9.82203 24.0633 8.97794 24.0633 8.45732 23.5426C7.93669 23.022 7.93669 22.1779 8.45731 21.6573L14.1146 16L8.45732 10.3426C7.9367 9.82203 7.93669 8.97794 8.45732 8.45732C8.97794 7.93669 9.82203 7.93669 10.3426 8.45732L16 14.1146Z" fill="#0E2242"/>
          </g>
          <defs>
            <clipPath id="clip0_6399_13262">
              <rect width="32" height="32" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <div class="modal-cookie_body body">
      <div class="body_wrapper">
        <div class="body_text" v-html="$t('cookie.descriptionForAll')"/>

        <slot name="blocks"></slot>
      </div>
    </div>

    <div class="modal-cookie_footer footer">
      <ac-button
        v-if="isModal"
        variant="outlined"
        class="footer_button"
        @click="dismiss"
      >
        {{ $t('cookie.dismiss') }}
      </ac-button>

      <ac-button
        class="footer_button"
        @click="accept"
        :disabled="disabledAcceptBtn"
      >
        {{ $t('cookie.agreeSelected') }}
      </ac-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AcButton from '@ui-kit/components/AcButton.vue'

export default defineComponent({
  name: 'AcCookieModalContent',
  components: {
    AcButton
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: true
    },
    disabledAcceptBtn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'dismiss', 'accept'],
  setup (props, ctx) {
    function close () {
      ctx.emit('close')
    }

    function dismiss () {
      ctx.emit('dismiss')
    }

    function accept () {
      ctx.emit('accept')
    }

    return {
      close,
      dismiss,
      accept
    }
  }
})
</script>

<style lang="scss" scoped>
.modal-cookie {
  background-color: var(--ac-color-white);
  border-radius: 8px;
  z-index: 99999;
  width: 100%;
  user-select: none;
  overflow: hidden;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;

  &.-isModal {
    max-width: 90%;
    max-height: 90%;
    width: 800px;
  }

  &_header {
    padding: 0 0 8px 0;
  }

  &.-isModal &_header {
    padding: 28px 54px 20px 54px;
    border-bottom: 1px solid #D9D9D9;
  }

  &_body {
    padding: 0 0 20px 0;
  }

  &.-isModal &_body {
    padding: 20px 44px 20px 54px;
  }

  &_footer {
    padding: 0;
  }

  &.-isModal &_footer {
    border-top: 1px solid #D9D9D9;
    padding: 20px 54px 28px 54px;
  }
}

.header {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &_close {
    cursor: pointer;
  }

  &_title {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;

    @media (max-width: 650px) {
      font-size: 16px;
      line-height: 140%;
    }
  }
}

.body {
  width: 100%;
  overflow: hidden;
  display: flex;

  &_wrapper {
    padding-right: 8px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }
    &::-webkit-scrollbar-button:vertical:decrement {
      background: transparent;
      height: 0;
    }
    &::-webkit-scrollbar-button:vertical:increment {
      background: transparent;
      height: 0;
    }
    &::-webkit-scrollbar-track {
      background: #DBE8FE;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--ac-color-blue);
      border-radius: 10px;
      background-clip: content-box;
      box-sizing: content-box;
      box-shadow: inset 0 0 10px 10px transparent;
    }
  }

  &_text {
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 140%;
    border-bottom: 1px solid #D9D9D9;
    margin-bottom: 10px;
    padding-bottom: 12px;

    @media (max-width: 500px) {
      font-size: 12px;
    }
  }
}

.footer {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 600px) {
    flex-flow: column nowrap;
  }

  &_button {
    width: 100%;
    margin-right: 20px;

    @media (max-width: 600px) {
      margin-right: 0;
      margin-bottom: 20px;
    }

    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
}
</style>
